<template>
  <div class="custom-switch-billing">
    <b-form-checkbox v-model="subscription.add_premium_receipt_as_cost" @change="addPremiumReceiptAsCost()" switch size="lg">
      <translate>Add subscription invoices automatically as costs</translate>
      <font-awesome-icon id="tt_receipts_as_cost" icon="fa-solid fa-circle-info" class="text-info ml-1" />
      <b-tooltip target="tt_receipts_as_cost" triggers="hover">
          {{ $gettext('If you select this option, the invoices that Gekko sends you, will be automatically added to your expenses. Please be aware that you do not duplicate your costs by uploading the copy you receive via email.') }}
      </b-tooltip>
    </b-form-checkbox>
  </div>
</template>

<script>
import SubscriptionService from "@/store/services/subscriptions.service";

export default {
  name: "AddPremiumReceiptAsCost",
  data() {
    return {
      subscription: {},
    }
  },
  created() {
      let vm = this;

      SubscriptionService.retrieveCurrent().then(function (response) {
        vm.subscription = response.data;
      });
    },
  methods: {
    addPremiumReceiptAsCost(){
      SubscriptionService.update(this.subscription.id, {add_premium_receipt_as_cost: this.subscription.add_premium_receipt_as_cost});
    }
  }
}
</script>

<style lang="scss">
.custom-switch-billing {
  padding: 1rem;
  border-radius: $radiusLg;
  background: white;
  box-shadow: $settingShadow;
  .custom-switch.b-custom-control-lg {
    .custom-control-label {
      font-size: 16px !important;
      &:before, &:after {
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .custom-control-input:checked ~ .custom-control-label::after {
      transform: translate(0.9375rem, -50%);
    }
  }
}

</style>
